export default __webpack_public_path__ + "/dist/images/image8.png";